module.exports = __webpack_public_path__ + "static/media/fa-regular-400.cc440dd7.eot";